<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row mb-3x">
    <div class="col-sm-12 col-lg-12 d-flex common-ui-switch-parent">
      <common-ui-switch (checkedChange)="onShowKonzernChanged($event)" [(checked)]="showKonzern"
                        [readonly]="readonly" id="switchKonzern{{index}}"></common-ui-switch>
      <label class="label">
        {{ konzernSwitchTranslation }}
      </label>
    </div>
  </div>

  <div *ngIf="showKonzern">
    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="nameKonzern{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.KONZERN.NAME_KONZERN' | translate }}</label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="nameKonzern{{objectId}}" formControlName="nameKonzern" id="nameKonzern{{index}}"
               type="text"
               utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage/>
      </div>
    </div>

    <common-ui-steuernummer [(data)]="data.steuernummer" [readonly]="readonly" index="2"></common-ui-steuernummer>

    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="wirtschaftsIdNummer{{index}}">{{ 'COMMON_UI.STEUERIDENTIFIKATION.WIRTSCHAFTS_ID_NUMMER' | translate }}</label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="wirtschaftsIdNummer{{objectId}}" formControlName="wirtschaftsIdNummer"
               id="wirtschaftsIdNummer{{index}}" type="text"
               utilsCheckValidity utilsControlState utilsValidationMessage/>
      </div>
    </div>

    <div *ngIf="showAmtsgericht">
      <div class="form-row">
        <label class="col-sm-4 col-form-label"
               for="amtsgericht">{{ 'COMMON_UI.FRAGEBOGEN.KONZERN.AMTSGERICHT' | translate }}
        </label>
        <div class="col-sm-8">
          <input class="form-control" datevMessagePath="amtsgericht{{objectId}}" formControlName="amtsgericht"
                 id="amtsgericht" type="text"
                 utilsCheckValidity utilsControlState utilsValidationMessage/>
        </div>
      </div>
    </div>

    <div *ngIf="showAuslandFields">
      <div class="form-row">
        <label class="col-sm-8 col-form-label"
               for="auslHrg">{{ 'COMMON_UI.FRAGEBOGEN.KONZERN.AUSL_HRG' | translate }}
        </label>
        <div class="col-sm-4">
          <input class="form-control" datevMessagePath="auslHrg{{objectId}}" formControlName="auslHrg"
                 id="auslHrg" type="text"
                 utilsCheckValidity utilsControlState utilsValidationMessage/>
        </div>
      </div>

      <div class="form-row">
        <label class="col-sm-8 col-form-label"
               for="auslHrgNr">{{ 'COMMON_UI.FRAGEBOGEN.KONZERN.AUSL_HRG_NR' | translate }}
        </label>
        <div class="col-sm-4">
          <input class="form-control" datevMessagePath="auslHrgNr{{objectId}}" formControlName="auslHrgNr"
                 id="auslHrgNr" type="text"
                 utilsCheckValidity utilsControlState utilsValidationMessage/>
        </div>
      </div>

      <div class="form-row">
        <label class="col-sm-8 col-form-label"
               for="inlHrg">{{ 'COMMON_UI.FRAGEBOGEN.KONZERN.INL_HRG' | translate }}
        </label>
        <div class="col-sm-4">
          <input class="form-control" datevMessagePath="inlHrg{{objectId}}" formControlName="inlHrg"
                 id="inlHrg" type="text"
                 utilsCheckValidity utilsControlState utilsValidationMessage/>
        </div>
      </div>
    </div>

    <div class="form-row">
      <label class="col-sm-8 col-form-label"
             for="handelsregisterBezeichnung{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.KONZERN.HANDELSREGISTER.BEZEICHNUNG' | translate }}</label>
      <div class="col-sm-4">
        <select class="form-control" datevMessagePath="handelsregisterBezeichnung{{objectId}}"
                formControlName="handelsregisterBezeichnung"
                id="handelsregisterBezeichnung{{index}}" utilsCheckValidity utilsControlState
                utilsMarkRequired
                utilsValidationMessage>
          <option [ngValue]="null" hidden
                  selected>{{ 'COMMON_UI.FRAGEBOGEN.KONZERN.HANDELSREGISTER.NULL' | translate }}</option>
          <option *ngFor="let value of enumKeys(handelsregisterBezeichnungEnum)"
                  [ngValue]="handelsregisterBezeichnungEnum[value]">
            {{ 'COMMON_UI.FRAGEBOGEN.KONZERN.HANDELSREGISTER.KEY_' + toTranslationKey(handelsregisterBezeichnungEnum[value]) | translate }}
          </option>
        </select>
      </div>
    </div>

    <div class="form-row">
      <label class="col-sm-8 col-form-label"
             for="handelsregisterNummer{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.KONZERN.HANDELSREGISTER_NUMMER' | translate }}</label>
      <div class="col-sm-4">
        <input class="form-control" datevMessagePath="handelsregisterNummer{{objectId}}" formControlName="handelsregisterNummer"
               id="handelsregisterNummer{{index}}" type="text"
               utilsCheckValidity utilsControlState utilsMarkRequired
               utilsValidationMessage/>
      </div>
    </div>
  </div>
</form>
